export const DOT_STRING_SPACER = '\u00A0•\u00A0';

export function capitalizeString(str: string): string {
    if (!str) {
        return '';
    }
    return str[0].toUpperCase() + str.slice(1);
}
export async function sha256(message: string) {
    if (!message) {
        return '';
    }
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    return hashHex;
}

export type MarkdownNode =
    | { type: 'text'; text: string }
    | { type: 'link'; text: string; href: string };

/**
 * Parses markdown links in text and returns an array of nodes
 * that can be rendered as text or links.
 */
export function parseMarkdownLinks(text: string): MarkdownNode[] {
    // Finds instances of markdown link in the format `[Link](http://example.com)`
    const linkRegex = /\[(.*?)\]\((.+?)\)/g;
    const nodes: MarkdownNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = linkRegex.exec(text)) !== null) {
        const [fullMatch, linkText, href] = match;
        const matchIndex = match.index;

        if (matchIndex > lastIndex) {
            nodes.push({
                type: 'text',
                text: text.slice(lastIndex, matchIndex),
            });
        }

        nodes.push({
            type: 'link',
            text: linkText,
            href,
        });

        lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < text.length) {
        nodes.push({
            type: 'text',
            text: text.slice(lastIndex),
        });
    }

    // If no links were found, return the original text
    return nodes.length === 0 ? [{ type: 'text', text }] : nodes;
}
